import {getProductCardOldTemplate, getProductCardTemplate} from "./template";

export const ShowMoreTemplate = {
  "product-card": (data, index) => getProductCardTemplate(data, index),
  "product-card-old": (data, index) => getProductCardOldTemplate(data, index),
};

export const TemplateType = {
  PRODUCT_CARD: "product-card",
  PRODUCT_CARD_OLD: "product-card-old",
};
